import _rayJs from "./ray.js";
import _lineJs from "./line.js";
import _pointJs from "./point.js";
import _vectorJs from "./vector.js";
import _numberJs from "./number.js";

var module = {
    exports: {}
};

var exports = module.exports;
module.exports = {
    number: _numberJs,
    vector: _vectorJs,
    point: _pointJs,
    line: _lineJs,
    ray: _rayJs,
};
export default module.exports;
